import { RightOutlined } from "@ant-design/icons";
import {
  Add,
  DeleteOutline,
  Factory,
  InfoOutlined,
  Person,
} from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { EditIcon } from "lucide-react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CircleIcon from "@mui/icons-material/Circle";
import BreakfastDiningIcon from "@mui/icons-material/BreakfastDining";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { newHost } from "./CategoryProfile";
import Camera from "../../assets/svg/Camera.svg";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import axios from "axios";
import "./Categories.css";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import DeleteModal from "../../components/Modals/DeleteModal";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";

const BrandCategoryProfile = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { id, subCatId, brandId } = useParams();

  console.log(useParams());

  const navigate = useNavigate();

  // table columns & rows

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex align-items-center justify-content-center gab-3">
            <span>{params?.row.sku}</span>
          </div>
        );
      },
    },
    {
      field: "unit",
      headerName: "Unit",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex align-items-center justify-content-center gab-3">
            <span>{params?.row.unit.name}</span>
          </div>
        );
      },
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex align-items-center justify-content-center gab-3">
            <span>{params?.row.quantity}</span>
          </div>
        );
      },
    },
    {
      field: "stock_status",
      headerName: "Reorder Point",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <CircleIcon
              fontSize="sm"
              sx={{ color: params.row?.stock_status_color }}
            />
            <p className="m-0">{params?.row?.stock_status}</p>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex align-items-center justify-content-center gab-3">
            <span>{params?.row.status}</span>
          </div>
        );
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const handleNavigate = (event) => {
          event.stopPropagation();
          navigate(
            subCatId
              ? `/Categories/${id}/subcategory/${subCatId}/brand/${brandId}/Products/${params.row?.id}`
              : `/Categories/${id}/brand/${brandId}/Products/${params.row?.id}`
          );
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleEditCategory(params.row);
              }}
              color="default"
              aria-label="edit"
              style={{ width: "30%" }}
              size="small"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                confirmDelete(params.row?.id);
              }}
              color="error"
              aria-label="delete"
              style={{ width: "30%" }}
              size="small"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={handleNavigate}
              color="default"
              aria-label="navigate"
              style={{ width: "30%" }}
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  // brand data

  const [brandCategoryId, setbrandCategoryId] = useState(null);

  const getBrandOfCategoryById = async () => {
    try {
      const response = await axios.get(`${newHost}portal/brands/${brandId}`, {
        headers: newHeaders,
      });
      console.log(response.data.data.brand);
      setbrandCategoryId(response.data.data.brand);
    } catch (error) {
      console.log(error);
    }
  };

  // brands products

  const [productsBrand, setProductsBrand] = useState([]);

  const getProductsOfBrandCategory = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/products-with-variations?category_id=${
          subCatId ? subCatId : id
        }&brand_id=${brandId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      setProductsBrand(response.data.data?.products);
    } catch (error) {
      console.log();
    }
  };

  // active functions

  const [showActivate, setShowActivate] = useState(false);

  const handleActivateShow = () => {
    setShowActivate(true);
  };

  const handleActivateClose = () => {
    setShowActivate(false);
  };

  const activatebrand = async () => {
    const isActive = brandCategoryId?.status === "active";
    const newStatus = isActive ? "inactive" : "active";

    try {
      const response = await axios.post(
        `${newHost}portal/brands/${brandId}`,
        {
          _method: "PATCH",
          status: newStatus,
        },
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      getBrandOfCategoryById();
      setShowActivate(false);
    } catch (error) {
      console.log(error);
    }
  };

  //  add & update product

  const [properties, setProperties] = useState([]);

  const [units, setUnits] = useState([]);

  const [status, setStatus] = useState([]);

  const [images, setImages] = useState([]);

  const [removedImages, setRemovedImages] = useState([]);

  const [addMainCatigory, setAddMainCatigory] = useState({
    profile_image: "",
    description: "",
    name: "",
    product_status: "",
    reorder_point: "",
    weight: "",
    unit_id: "",
    dimensions: "",
    property_values: [],
  });

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddMainCatigory({
      fileUrl: "",
      profile_image: "",
      description: "",
      name: "",
      product_status: "",
      reorder_point: "",
      weight: "",
      unit_id: "",
      dimensions: "",
      property_values: [],
    });
    reset();
    setImages([]);
    setIsEditing(false);
    setEditProductId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditProductId(null);
  };

  const onSubmitAddMainCatogiry = () => {
    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PUT");
    }

    formData.append("category_id", subCatId ? subCatId : id);
    formData.append("brand_id", brandId);
    formData.append("profile_image", addMainCatigory.profile_image);
    formData.append("name", addMainCatigory.name);
    formData.append("description", addMainCatigory.description);
    formData.append("product_status", addMainCatigory.product_status);
    formData.append(
      "reorder_point",
      parseInt(addMainCatigory.reorder_point || 0, 10)
    );
    formData.append("weight", addMainCatigory.weight);
    formData.append("unit_id", addMainCatigory.unit_id);
    formData.append("dimensions", addMainCatigory.dimensions);

    if (Array.isArray(addMainCatigory.property_values)) {
      addMainCatigory.property_values.forEach((item, index) => {
        formData.append(
          `property_values[${index}][property_id]`,
          item.property_id
        );
        formData.append(
          `property_values[${index}][property_value_id]`,
          item.property_value_id
        );
      });
    }

    const existingCount = images.filter((img) => img.isFromBackend).length;

    const newImages = images.filter((img) => !img.isFromBackend && img.file);

    newImages.forEach((img, i) => {
      const idx = existingCount + i;
      formData.append(`images[${idx}][file]`, img.file);
    });

    removedImages.forEach((id) => {
      formData.append("images_to_delete[]", String(id));
    });

    const url = isEditing
      ? `${newHost}portal/products-with-variations/${editProductId}`
      : `${newHost}portal/products-with-variations`;

    axios
      .post(url, formData, {
        headers: newHeaders,
      })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isEditing
            ? "Product Updated Successfully"
            : "New Product Added Successfully",
          { autoClose: 3000 }
        );
        setShow(false);
        setImages([]);
        setRemovedImages([]);
        getProductsOfBrandCategory();
        setIsEditing(false);
        setAddMainCatigory({
          profile_image: "",
          description: "",
          name: "",
          product_status: "",
          reorder_point: "",
          weight: "",
          unit_id: "",
          dimensions: "",
          property_values: [],
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const getProperties = async () => {
    const response = await axios.get(
      `${newHost}product_selections?category_id=${subCatId ? subCatId : id}`,
      {
        headers: newHeaders,
      }
    );
    console.log(response);
    setProperties(response.data.data.properties);
    setUnits(response.data.data.units);
    setStatus(response.data.data.product_statuses);
  };

  const [isEditing, setIsEditing] = useState(false);

  const [editProductId, setEditProductId] = useState(null);

  const handleEditCategory = (product) => {
    console.log(product);

    const fullImageUrl = product?.profile_image_url?.startsWith("http")
      ? product.profile_image_url
      : product?.profile_image_url
      ? `https://estbn.com/EstbnNew/public${product.profile_image_url}`
      : "";

    const mappedPropertyValues = [];
    const propertyValueMap = {};

    if (product.property_values && Array.isArray(product.property_values)) {
      product.property_values.forEach((propVal) => {
        const propertyId = Number(propVal.property_id);
        const matchingProp = properties.find((p) => p.id === propertyId);

        if (matchingProp) {
          const matchedValue = matchingProp.values.find(
            (v) => v.value === propVal.value
          );

          if (matchedValue) {
            mappedPropertyValues.push({
              property_id: propertyId,
              property_value_id: matchedValue.id,
            });

            propertyValueMap[propertyId] = matchedValue.id;
            setValue(`property_values.${propertyId}`, matchedValue.id);
          }
        }
      });
    }

    const existingImages =
      product.images?.map((img) => ({
        id: img.id,
        preview: img.image_url.startsWith("http")
          ? img.image_url
          : `${`https://estbn.com/EstbnNew/public`}${img.image_url}`,
        file: null,
        isFromBackend: true,
      })) || [];

    setImages(existingImages);

    setAddMainCatigory({
      profile_image: "",
      description: product.description,
      name: product.name,
      product_status: product.status,
      reorder_point: product.reorder_point,
      weight: product.weight,
      unit_id: product.unit?.id,
      dimensions: product.dimensions,
      property_values: mappedPropertyValues,
      fileUrl: fullImageUrl,
    });

    setValue("name", product.name);
    setValue("description", product.description);
    setValue("product_status", product.status);
    setValue("reorder_point", product.reorder_point);
    setValue("weight", product.weight);
    setValue("unit_id", product.unit?.id);
    setValue("dimensions", product.dimensions);

    setIsEditing(true);
    setEditProductId(product.id);
    setShow(true);
  };

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  // delete product

  const [showDelete, setShowDelete] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setEditProductId(null);
    handleClose();
  };

  const confirmDelete = (id) => {
    setShowDelete(true);
    setEditProductId(id);
  };

  const deleteProduct = async () => {
    try {
      let response = await axios.delete(
        `${newHost}portal/products-with-variations/${editProductId}`,
        {
          headers: newHeaders,
        }
      );
      toast.warning("Product Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getProductsOfBrandCategory();
    } catch (error) {
      toast.error("Failed To Delete This Product.");
      console.log(error.message);
    }
  };

  useEffect(() => {
    getBrandOfCategoryById();
    getProductsOfBrandCategory();
    getProperties();
  }, []);

  return (
    <>
      {/* handle activation */}
      <Modal show={showActivate} onHide={handleActivateClose} className="">
        <>
          <div className="text-center py-3">
            {" "}
            <h3>
              {brandCategoryId?.status === "active" ? "Inactivate" : "Activate"}{" "}
              Brand
            </h3>
          </div>
          <div className="text-center">
            <h6 style={{ color: "#535353" }} className="fs-4">
              Are you sure you want to{" "}
              {brandCategoryId?.status === "active" ? "inactivate" : "activate"}{" "}
              <span className="fw-bold d-block">
                {brandCategoryId?.name} brand?
              </span>
            </h6>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-center gap-3 py-3">
              <button
                onClick={handleActivateClose}
                className="btn btn-light px-5"
              >
                Cancel
              </button>
              <button
                onClick={activatebrand}
                className={`btn  ${
                  brandCategoryId?.status == "active"
                    ? "btn-danger"
                    : "btn-success"
                } px-5`}
              >
                {brandCategoryId?.status == "active"
                  ? "Inactivate brand"
                  : "Activate brand"}
              </button>
            </div>
          </div>
        </>
      </Modal>
      {/* delete product  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this product?"}
        deleteFunction={deleteProduct}
      />
      {/* add product  */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Update Product" : "Add New Product"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* image  */}
            <div className="flex-center-x-y">
              <input
                type="file"
                accept="image/jpeg,image/png,image/jpg,image/gif,image/webp"
                style={{ display: "none" }}
                id="icon_url"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/svg+xml",
                      "image/gif",
                      "image/webp",
                    ];
                    if (allowedTypes.includes(file.type)) {
                      const imageUrl = URL.createObjectURL(file);
                      setAddMainCatigory({
                        ...addMainCatigory,
                        profile_image: file,
                        fileUrl: imageUrl,
                      });
                    } else {
                      toast.error("Please select a valid image file.");
                      setAddMainCatigory({
                        ...addMainCatigory,
                        profile_image: "",
                        fileUrl: "",
                      });
                    }
                  }
                }}
              />
              <label htmlFor="icon_url" className="categories_photo">
                {addMainCatigory.fileUrl ? (
                  <img
                    className="categories-add"
                    src={addMainCatigory.fileUrl}
                    alt="Selected"
                  />
                ) : (
                  <>
                    <img
                      className="categories-add"
                      src={AddPhoto}
                      alt="Placeholder"
                    />
                    <div className="categories_cameraIcon">
                      <img src={Camera} alt="Camera Icon" />
                    </div>
                  </>
                )}
              </label>
              {errors.profile_image && (
                <p className="danger">{errors.profile_image.message}</p>
              )}
            </div>
            {/* name */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-3"
                  label="Name"
                  placeholder="Enter Name"
                  variant="outlined"
                  value={addMainCatigory.name}
                  {...register("name", {
                    required: "Name Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        name: e.target.value,
                      });
                    },
                  })}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
            </div>
            {/* unit & status  */}
            <div className="row">
              {/* unit  */}
              <div className="col-6">
                <Controller
                  name="unit_id"
                  control={control}
                  rules={{ required: "Unit is required" }}
                  render={({ field }) => (
                    <FormControl
                      className="w-100 mb-3"
                      variant="outlined"
                      error={!!errors.unit_id}
                    >
                      <InputLabel id="unit-label">Unit</InputLabel>
                      <Select
                        labelId="unit-label"
                        label="Unit"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e);
                          setAddMainCatigory((prev) => ({
                            ...prev,
                            unit_id: e.target.value,
                          }));
                        }}
                      >
                        {units.map((unit) => (
                          <MenuItem
                            key={unit.id}
                            className="custom-menu-item"
                            value={unit.id}
                          >
                            {unit.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.unit_id && (
                  <p className="danger">{errors.unit_id.message}</p>
                )}
              </div>
              {/* status  */}
              <div className="col-6">
                <Controller
                  name="product_status"
                  control={control}
                  rules={{ required: "Status is required" }}
                  render={({ field }) => (
                    <FormControl
                      className="w-100 mb-3"
                      variant="outlined"
                      error={!!errors.product_status}
                    >
                      <InputLabel id="status-label">Status</InputLabel>
                      <Select
                        labelId="status-label"
                        label="Status"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e);
                          setAddMainCatigory((prev) => ({
                            ...prev,
                            product_status: e.target.value,
                          }));
                        }}
                      >
                        {status.map((st) => (
                          <MenuItem
                            className="custom-menu-item"
                            key={st.value}
                            value={st.value}
                          >
                            {st.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.product_status && (
                  <p className="danger">{errors.product_status.message}</p>
                )}
              </div>
            </div>
            {/* weight & dimensions  */}
            <div className="row">
              {/* weight  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  label="Weight"
                  placeholder="Enter Weight"
                  variant="outlined"
                  value={addMainCatigory.weight}
                  {...register("weight", {
                    required: "Weight Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        weight: e.target.value,
                      });
                    },
                  })}
                />
                {errors.weight && (
                  <p className="danger">{errors.weight.message}</p>
                )}
              </div>
              {/* dimensions */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  label="Dimensions"
                  placeholder="Enter Dimensions"
                  variant="outlined"
                  {...register("dimensions", {
                    required: "Dimensions Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        dimensions: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.dimensions}
                />
                {errors.dimensions && (
                  <p className="danger">{errors.dimensions.message}</p>
                )}
              </div>
            </div>
            {/* reorder & properties */}
            <div className="row">
              {/* reorder  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  type="number"
                  label="Reorder Point"
                  placeholder="Enter Number"
                  variant="outlined"
                  {...register("reorder_point", {
                    required: "Reorder_point Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        reorder_point: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.reorder_point}
                />
                {errors.reorder_point && (
                  <p className="danger">{errors.reorder_point.message}</p>
                )}
              </div>
              {/* properties  */}
              {properties.map((prop) => (
                <div className="col-6" key={prop.id}>
                  <Controller
                    name={`property_values.${prop.id}`}
                    control={control}
                    rules={{ required: `${prop.name} is required` }}
                    render={({ field }) => (
                      <FormControl
                        className="w-100 mb-3"
                        variant="outlined"
                        error={!!errors.property_values?.[prop.id]}
                      >
                        <InputLabel id={`prop-${prop.id}`}>
                          {prop.name}
                        </InputLabel>
                        <Select
                          labelId={`prop-${prop.id}`}
                          label={prop.name}
                          value={field.value || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            field.onChange(selectedValue);

                            const currentProperties = Array.isArray(
                              addMainCatigory.property_values
                            )
                              ? addMainCatigory.property_values
                              : [];

                            const updatedValues = currentProperties.map(
                              (item) => {
                                if (item.property_id === prop.id) {
                                  return {
                                    ...item,
                                    property_value_id: selectedValue,
                                  };
                                }
                                return item;
                              }
                            );

                            const isExisting = currentProperties.some(
                              (item) => item.property_id === prop.id
                            );

                            const finalValues = isExisting
                              ? updatedValues
                              : [
                                  ...currentProperties,
                                  {
                                    property_id: prop.id,
                                    property_value_id: selectedValue,
                                  },
                                ];

                            setAddMainCatigory((prev) => ({
                              ...prev,
                              property_values: finalValues,
                            }));
                          }}
                        >
                          {prop.values.map((value) => (
                            <MenuItem
                              key={value.id}
                              className="custom-menu-item"
                              value={value.id}
                            >
                              {value.value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                  {errors.property_values?.[prop.id] && (
                    <p className="danger">
                      {errors.property_values[prop.id]?.message}
                    </p>
                  )}
                </div>
              ))}
            </div>
            {/* description  */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-3"
                  label="Category Description"
                  variant="outlined"
                  rows={4}
                  multiline
                  {...register("description", {
                    required: "Description Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        description: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.description}
                />
                {errors.description && (
                  <p className="danger">{errors.description.message}</p>
                )}
              </div>
            </div>
            {/* Multiple Images Upload Section */}
            <div className="mb-4">
              <div className=" d-flex justify-content-between align-items-center">
                <label className="form-label fw-bold">Attachments</label>
                <input
                  type="file"
                  id="galleryImages"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const selectedFiles = Array.from(e.target.files);
                    const validFiles = selectedFiles.filter((file) =>
                      [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "image/gif",
                        "image/svg+xml",
                      ].includes(file.type)
                    );

                    if (validFiles.length !== selectedFiles.length) {
                      toast.error(
                        "Some files were skipped (invalid image types)"
                      );
                    }

                    const newImages = validFiles.map((file) => ({
                      file,
                      preview: URL.createObjectURL(file),
                      isFromBackend: false,
                    }));

                    setImages((prev) => [...prev, ...newImages]);
                  }}
                />
                <label
                  htmlFor="galleryImages"
                  className="btn btn-light d-flex align-items-center gap-2"
                >
                  <i className="bi bi-upload" style={{ fontSize: "1rem" }}></i>
                  Add Images
                </label>
              </div>
              <div className="d-flex justify-content-evenly align-items-center flex-wrap gap-2 mt-3">
                {images.map((img, index) => (
                  <div
                    key={index}
                    className="position-relative d-flex justify-content-center align-items-center my-1"
                    style={{
                      width: "22%",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      height: "100px",
                    }}
                  >
                    <img
                      src={img.preview}
                      alt={`preview-${index}`}
                      style={{
                        width: "90%",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setImages((prev) => prev.filter((_, i) => i !== index));
                        if (img.isFromBackend && img.id) {
                          setRemovedImages((prev) => [...prev, img.id]);
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: "22px",
                        height: "22px",
                        cursor: "pointer",
                        paddingBottom: "4px",
                      }}
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="min-vh-100 mx-4 my-3">
        {/* Head Section */}
        <div className="row align-items-center mb-3">
          <div className="col-12 col-sm-5 mb-2 mb-sm-0">
            <h5 className="fw-semibold m-0">Brand Profile</h5>
          </div>
          <div className="col-12 col-sm-7 text-start text-sm-end">
            <button
              onClick={handleActivateShow}
              className={`btn ${
                brandCategoryId?.status === "active"
                  ? "btn-danger"
                  : "btn-success"
              } px-3 py-2`}
              style={{
                whiteSpace: "nowrap",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              {brandCategoryId?.status === "active"
                ? "Inactivate Brand"
                : "Activate Brand"}
            </button>
          </div>
        </div>
        <div className="row gy-4">
          {/* Side Data */}
          <div className="col-12 col-lg-4 col-xl-3">
            <div className="border border-2 rounded-3 p-3 h-100">
              <div className="bg-light rounded-4 text-center px-3 py-2">
                <div className="supplier_imgHulder">
                  <img
                    src={`https://estbn.com/EstbnNew/public${brandCategoryId?.logo_path}`}
                    alt="Brand Logo"
                    className="img-fluid"
                  />
                </div>
              </div>

              <div className="mt-4">
                <h5 className="fw-bold">{brandCategoryId?.name}</h5>
              </div>

              <div className="stuffprofileinfo_supplierProfile mt-4">
                <h6 className="fw-medium">Brand Info</h6>

                <div className="d-flex gap-2 align-items-center my-1">
                  <Person fontSize="small" />
                  <p className="categoryInfo fw-semibold m-0">
                    Created by {brandCategoryId?.operator?.name}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <CalendarTodayIcon fontSize="small" />
                  <p className="categoryInfo fw-semibold m-0">
                    Created On{" "}
                    {new Date(brandCategoryId?.created_at).toLocaleDateString()}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center my-1">
                  {brandCategoryId?.status === "active" ? (
                    <CircleIcon fontSize="small" color="success" />
                  ) : (
                    <CircleIcon fontSize="small" />
                  )}
                  <p className="categoryInfo fw-semibold m-0">
                    {brandCategoryId?.status}
                  </p>
                </div>

                <div className="d-flex gap-2 align-items-center my-1">
                  <InfoOutlined fontSize="small" />
                  <p className="categoryInfo my-0">
                    {brandCategoryId?.description}
                  </p>
                </div>

                <div className="d-flex gap-2 align-items-center my-1">
                  <BreakfastDiningIcon fontSize="small" />
                  <p className="categoryInfo fw-semibold my-0">
                    {`${brandCategoryId?.total_variations} Products`}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <Factory fontSize="small" />
                  <p className="categoryInfo fw-semibold m-0">
                    {brandCategoryId?.manufacturer?.name}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Table Data */}
          <div className="col-12 col-lg-8 col-xl-9">
            <div className="border border-2 rounded-3 p-3 min-vh-100">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2 gap-3">
                <h4 className="m-0">Product Variations</h4>
                <button className="btn btn-light" onClick={handleShow}>
                  <Add />
                  Add Product Variation
                </button>
              </div>
              {productsBrand?.length > 0 ? (
                <div className="scrollable-table-wrapper">
                  <div>
                    <Paper sx={{ width: "100%" }}>
                      <DataGrid
                        rows={productsBrand}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[5, 10, 20, 50]}
                        checkboxSelection
                        sx={{ border: 0 }}
                        slotProps={{
                          pagination: {
                            sx: {
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "center",
                            },
                          },
                        }}
                      />
                    </Paper>
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center w-100"
                  style={{ minHeight: "300px" }}
                >
                  <NotFound
                    paragraphText={
                      "No Products yet. All your Products will appear here once you get started."
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandCategoryProfile;
